const cronParser = require('cron-parser');

// All crontabs stored in the backend use America/Bogota as their reference
// timezone. Parse expressions in that same timezone so the next-execution
// calculation matches what celery beat will actually fire, regardless of
// where the browser is physically located.
const CRON_TZ = 'America/Bogota';

/**
 * Compute the next N cron firings.
 *
 * @param {object} cronObject - { minute, hour, day_of_month, month_of_year, day_of_week }
 * @param {number} limit - how many upcoming dates to return
 * @param {Date|string} finalDate - optional upper bound; dates after this are filtered out
 * @param {Date} startTime - optional lower bound (Colombia real instant). If provided,
 *     only firings at or after this time are returned. Mirrors django-celery-beat's
 *     PeriodicTask.start_time semantics so the preview matches what celery will do.
 *     If omitted, the preview starts from "now".
 */
export const getCronNextDates = (cronObject, limit = 5, finalDate, startTime) => {
    let dates = [];
    const parseOptions = { tz: CRON_TZ };
    if (startTime) {
        // cron-parser's `currentDate` is exclusive: next() returns the first firing
        // strictly after currentDate. Subtract 1 ms so that if the user picked a
        // time that coincides exactly with a cron firing, that firing is included.
        const startTimeObj = startTime instanceof Date ? startTime : new Date(startTime);
        parseOptions.currentDate = new Date(startTimeObj.getTime() - 1);
    }
    let cronInterval = cronParser.parseExpression(
        cronObject.minute + ' ' + cronObject.hour + ' '
        + cronObject.day_of_month + ' ' + cronObject.month_of_year + ' ' + cronObject.day_of_week,
        parseOptions
    );

    for (let i = 0; i < limit; i++) {
        dates.push(new Date(cronInterval.next().toString()));
    }

    // Normalize finalDate to a Date object so the comparison below is numeric
    // (not string-based). Previously, passing a string here caused silent
    // misfiltering because `Date <= string` coerces the Date to its string
    // form and compares alphabetically.
    if (finalDate) {
        const finalDateObj = finalDate instanceof Date ? finalDate : new Date(finalDate);
        dates = dates.filter(item => item <= finalDateObj);
    }

    return dates;
}